// future consideration: https://maplibre.org/projects/gl-js/

import debounce from 'debounce';
import select from 'dom-select';
import L from 'leaflet';

import { GestureHandling } from 'leaflet-gesture-handling';

import imgPinIcon from '@images/leaflet/marker-icon.svg';
import imgPinIconATM from '@images/leaflet/marker-icon-atm.svg';
import imgPinShadow from '@images/leaflet/marker-shadow.svg';

import Mark from 'mark.js';

export const Openstreetmap = (el) => {
  const ui = {
    el,
    body: select('body', document),
    toggle: select('#js-map-toggle', el),
    mapContainer: select('.openstreetmap__map', el),
    allLinks: select.all('.openstreetmap__link', el),
    allCheckboxes: select.all('.input-group .input', el),
    context: select('.openstreetmap__links', el),
    textFilter: select('.text-filter', el),
    formReset: select('.form [type="reset"]', el),
    areaFilter: select('#filter-area', el),
    serviceFilter: select('#filter-service', el),
    centerFilter: select('#filter-center', el),
  };

  // OSM Map
  // jawg access
  const accessToken = '38K30LTF6vlYM1Tx8OFce5wkA2A86kQ8SIsg2PSlV3FmNklNYAWP7bz4d0PSiJRn';
  const latitude = ui.mapContainer.getAttribute('data-latitude');
  const longitude = ui.mapContainer.getAttribute('data-longitude');
  const zoom = ui.mapContainer.getAttribute('data-zoom');
  const minZoom = ui.mapContainer.getAttribute('data-min-zoom');

  L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

  const map = L.map(ui.mapContainer, {
    center: [latitude, longitude],
    gestureHandling: true,
    minZoom: minZoom,
    zoom: zoom,
    // zoomSnap: .25,
    wheelPxPerZoomLevel: 120,
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: 'bottomleft'
    }
  });

  const iconStyles = L.icon({
    iconUrl: imgPinIcon,
    shadowUrl: imgPinShadow,
    iconAnchor: [16, 51],
    popupAnchor: [-3, -76],
    shadowSize: [68, 95],
    shadowAnchor: [24, 100],
  });

  const iconStylesATM = L.icon({
    iconUrl: imgPinIconATM,
    shadowUrl: imgPinShadow,
    iconAnchor: [16, 51],
    popupAnchor: [-3, -76],
    shadowSize: [68, 95],
    shadowAnchor: [24, 100],
  });

  let markerGroup = L.layerGroup().addTo(map);
  const threshold = 834;

  // input filters
  let filtersType = [];
  let filtersArea = [];
  let filtersService = [];
  let filtersCenter = [];

  const setMapTiles = () => {
    // Create a Tile Layer for the background
    let tiles = new L.tileLayer('https://tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=' + accessToken, {
      // Required by Jawg: https://www.jawg.io/docs/integration/leaflet/#attribution
      attribution: '<a href="https://www.jawg.io?utm_medium=map&utm_source=attribution" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org?utm_medium=map-attribution&utm_source=jawg" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors',
    });
    tiles.addTo(map);
  }

  const clearMapMarkers = () => {
    markerGroup.clearLayers();
  }

  const updateFiltersQueryString = () => {
    if (window.isTurnStorybook) return;
    const query = new URLSearchParams();
    if (ui.textFilter?.value) query.append('q', ui.textFilter.value);
    if (filtersType.length > 0) query.append('type', filtersType.join(','));
    if (filtersArea.length > 0) query.append('area', filtersArea[0]);
    if (filtersService.length > 0) query.append('service', filtersService[0]);
    if (filtersCenter.length > 0) query.append('center', filtersCenter[0]);
    if (ui.el.classList.contains('list-view')) query.append('m', '0');
    let url = window.location.href.split('?')[0];
    if (query.size > 0) url = `${url}?${query.toString().replaceAll('%2C', ',')}`;
    window.history.pushState(null, '', new URL(url));
  }

  const isAtmOnly = (link) => {
    const services = (link.getAttribute('data-service') || '')
      .split(',')
      .map(s => s.trim().toLowerCase())
      .filter(Boolean);
    return services.includes('atm') && !services.includes('branch');
  };

  const setMapMarkers = (skipUpdateQuery) => {
    filterItems();
    clearMapMarkers();
    if (skipUpdateQuery !== true) updateFiltersQueryString();

    ui.allLinks.forEach(link => {
      let popupContent;

      if (link.classList.contains('include')) {
        const latitude = link.getAttribute('data-latitude');
        const longitude = link.getAttribute('data-longitude');
        const title = link.getAttribute('data-title');
        const popupEl = select('.js-popup-content', link);
        popupContent = popupEl && popupEl.innerHTML ? popupEl.innerHTML : 'No data';
        const markerIcon = isAtmOnly(link) ? iconStylesATM : iconStyles;

        const marker = L.marker(
          [latitude, longitude],
          {
            icon: markerIcon,
            draggable: false,
            // The location list below the map is the keyboard route; 45 marker
            // tab stops (many overlapping) were unusable
            keyboard: false,
            title: title,
          }
        );

        marker.addTo(markerGroup).bindPopup(popupContent);
      }
    });
    //  debug();
  }

  // input filtering
  const filterItems = () => {
    ui.allLinks.forEach(link => {
      link.classList.remove('include');
    });

    ui.allLinks.forEach(link => {
      let passesType = true;
      let passesArea = true;
      let passesService = true;
      let passesCenter = true;

      if (filtersType.length) {
        const dataTypes = link.getAttribute('data-location-type').split(',').map(s => s.trim());
        passesType = filtersType.some(type => dataTypes.includes(type));
      }
      if (filtersArea.length) {
        passesArea = filtersArea.includes(link.getAttribute('data-area'));
      }
      if (filtersService.length) {
        const dataServices = link.getAttribute('data-service').split(',').map(s => s.trim());
        passesService = filtersService.some(service => dataServices.includes(service));
      }
      if (filtersCenter.length) {
        passesCenter = filtersCenter.includes(link.getAttribute('data-center'));
      }

      if (passesType && passesArea && passesService && passesCenter) {
        link.classList.add('include');
      }
    });

    // integrate our filtering with MarkJS
    if (el.getAttribute('data-filtered-by-text')) {
      const allNonMarkedLinks = select.all('.openstreetmap__link:not(:has(mark))', el);
      allNonMarkedLinks.forEach(link => {
        link.classList.remove('include');
      });
    }

    el.classList.toggle('no-results', select.all('.include', el).length === 0);
  }

  // text filtering via MarkJS
  if (ui.context) {
    var instance = new Mark(ui.context);
    var options = {
      'exclude': ['.openstreetmap__link__cta', '.openstreetmap__link__cta *'],
      'ignorePunctuation': [
        '`',
        "'",
        'ʻ', // respect the okina
        '’',
      ],
      'debug': false,
      'separateWordSearch': true,
      'done': function() {
        setMapMarkers();
      }
    }
  }

  const clearMarks = () => {
    ui.el.removeAttribute('data-filtered-by-text');
    instance.unmark();
  };

  const addMarks = (term, skipUpdateQuery) => {
    if (term) {
      instance.unmark();
      instance.mark(term, options);
      ui.el.setAttribute('data-filtered-by-text', 'true');
    } else {
      ui.el.removeAttribute('data-filtered-by-text');
      clearMarks();
    }
    setMapMarkers(skipUpdateQuery);
  }

  const debouncedAddMarks = debounce(addMarks, 200);

  const fitHawaiianIslandsBounds = () => {
    // console.log('fitHawaiianIslandsBounds fired');
    // Define bounding box for all main Hawaiian islands
    const hawaiianIslandsBounds = [
      [18.9, -160.3], // Southwest corner (Big Island south, Kauai west)
      [22.3, -154.7]  // Northeast corner (Kauai north, Big Island east)
    ];

    // Fit the map to show all Hawaiian islands with some padding
    map.fitBounds(hawaiianIslandsBounds, {
      padding: [20, 20], // Add 20px padding on all sides
      maxZoom: 9 // Prevent zooming in too far
    });
  };

  const toggleView = () => {
    const wasListView = ui.el.classList.contains('list-view');
    ui.el.classList.toggle('list-view');

    // If switching FROM list view TO map view, recalculate map
    if (wasListView && !ui.el.classList.contains('list-view')) {
      // Give the CSS transition time to complete, then invalidate size and fit bounds
      setTimeout(() => {
        map.invalidateSize();
        fitHawaiianIslandsBounds();
      }, 100);
    }

    updateFiltersQueryString();
  }

  const reset = () => {
    ui.el.removeAttribute('data-area');
    ui.el.removeAttribute('data-service');
    ui.el.removeAttribute('data-center');
    ui.el.removeAttribute('data-filtered-by-type');
    ui.el.removeAttribute('data-filtered-by-text');
    ui.el.classList.remove(...ui.allCheckboxes.map(cb => cb.value));
    ui.allCheckboxes.forEach(checkbox => checkbox.removeAttribute('checked'));
    filtersType = [];
    filtersArea = [];
    filtersService = [];
    filtersCenter = [];
    ui.textFilter.value = '';
    if (ui.areaFilter) ui.areaFilter.value = '';
    if (ui.serviceFilter) ui.serviceFilter.value = '';
    if (ui.centerFilter) ui.centerFilter.value = '';
    clearMarks();
  }

  const getCheckboxValues = () => {
    // clear the array
    filtersType = [];
    // rebuild it
    filtersType = ui.allCheckboxes
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);
  }

  const handleResize = () => {
    switchToListView();
    map.invalidateSize();

    // If we're in map view after resize, ensure proper bounds
    if (!ui.el.classList.contains('list-view')) {
      setTimeout(() => {
        fitHawaiianIslandsBounds();
      }, 50);
    }
  }

  const switchToListView = () => {
    if (ui.body.offsetWidth < threshold) {
      // only execute this if ui.el DOESN'T have data-list-view="true"
      if (ui.el.getAttribute('data-list-view') !== 'true') {
        ui.el.classList.add('list-view');
        if (ui.toggle) {
          ui.toggle.checked = false;
        }
      }
    } else {
      if (ui.el.getAttribute('data-list-view') !== 'true') {
        ui.el.classList.remove('list-view');
        if (ui.toggle) {
          ui.toggle.checked = true;
        }
      }
    }
  }

  const checkInitialViewState = () => {
    if (ui.el.getAttribute('data-list-view') === 'true') {
      ui.el.classList.add('list-view');
      if (ui.toggle) {
        ui.toggle.checked = false;
      }
    } else {
      return;
    }
  }

  const updateFiltersArea = () => filtersArea = ui.areaFilter?.value ? [ui.areaFilter.value] : [];
  const updateFiltersCenter = () => filtersCenter = ui.centerFilter?.value ? [ui.centerFilter.value] : [];
  const updateFiltersService = () => filtersService = ui.serviceFilter?.value ? [ui.serviceFilter.value] : [];

  const addEvents = () => {
    checkInitialViewState();

    if (ui.toggle) {
      ui.toggle.addEventListener('change', () => {
        toggleView();
      });
    }

    if (ui.formReset) {
      ui.formReset.addEventListener('click', (event) => {
        event.preventDefault();
        reset();
        setMapMarkers();
      });
    }

    if (ui.textFilter) {
      ui.textFilter.addEventListener('keyup', () => {
        debouncedAddMarks(ui.textFilter.value);
      });
    }

    if (ui.areaFilter) {
      ui.areaFilter.addEventListener('change', () => {
        updateFiltersArea();
        setMapMarkers();
      });
    }

    if (ui.centerFilter) {
      ui.centerFilter.addEventListener('change', () => {
        updateFiltersCenter();
        setMapMarkers();
      });
    }

    if (ui.serviceFilter) {
      ui.serviceFilter.addEventListener('change', () => {
        updateFiltersService();
        setMapMarkers();
      });
    }

    ui.allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          el.classList.add(checkbox.value);
        } else {
          el.classList.remove(checkbox.value);
        }

        getCheckboxValues();
        setMapMarkers();
      });
    });

    window.onresize = debounce(() => {
      handleResize();
    }, 200);
  };

  const applyFiltersOnInit = () => {
    updateFiltersArea();
    updateFiltersCenter();
    updateFiltersService();
    const checkedCheckboxes = ui.allCheckboxes?.filter(checkbox => checkbox.checked) ?? [];
    if (checkedCheckboxes.length > 0) {
      el.classList.add(...checkedCheckboxes.map(checkbox => checkbox.value));
      getCheckboxValues();
    }
    const skipUpdateQuery = true;
    if (ui.textFilter?.value) addMarks(ui.textFilter.value, skipUpdateQuery);
    else setMapMarkers(skipUpdateQuery);
  };

  const init = () => {
    setMapTiles();

    // If starting in map view, fit to Hawaiian islands bounds
    if (!ui.el.classList.contains('list-view')) {
      fitHawaiianIslandsBounds();
    }

    applyFiltersOnInit();
    switchToListView();
    addEvents();
  };

  init();
};

export default Openstreetmap;
